<template>
  <div>
    <svg
      width="150"
      height="150"
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="width: 200px; height: 200px"
    >
      <path
        class="fillCls1"
        d="M92.1262 83.0339C92.0587 83.214 91.9911 83.4166 92.0362 83.6192C92.0812 83.7768 92.1937 83.9118 92.3063 84.0469C94.67 86.7933 97.0337 89.5397 99.3749 92.2861C98.9697 91.8134 100.095 88.7518 100.253 88.144C100.613 86.7708 100.996 85.3976 101.356 84.0244C101.806 82.291 103.63 77.5186 102.504 75.9202C101.401 74.367 97.574 76.8657 96.4934 77.6311C94.5574 78.9818 93.0041 80.8728 92.1262 83.0339Z"
        fill="#FDC485"
        stroke-width="2px"
        style="animation-duration: 1s"
      ></path>
      <path
        class="fillCls4"
        d="M141.157 44.4044L105.769 42.5134C105.184 42.4909 104.666 42.9186 104.576 43.5264L96.2918 96.0908C96.1792 96.8787 96.7195 97.6215 97.4624 97.6891L133.256 100.616C133.863 100.661 134.381 100.233 134.494 99.58L142.373 45.9577C142.485 45.2148 141.9 44.4494 141.157 44.4044Z"
        fill="#B7E3F0"
        stroke-width="2px"
        style="animation-duration: 1s"
      ></path>
      <path
        class="error4 fillCls6"
        d="M126.643 53.1893L120.985 78.2895H114.205L119.862 53.1893H126.643Z"
        fill="#FFFFFF"
        stroke-width="2px"
        style="animation-duration: 1s"
      ></path>
      <path
        class="error4 fillCls6"
        d="M113.073 87.9151C111.949 86.658 112.312 84.4999 113.883 83.095C115.455 81.69 117.64 81.5701 118.764 82.8272C119.888 84.0843 119.525 86.2424 117.954 87.6473C116.382 89.0523 114.197 89.1722 113.073 87.9151Z"
        fill="#FFFFFF"
        stroke-width="2px"
        style="animation-duration: 1s"
      ></path>
      <path
        class="fillCls5"
        d="M139.288 47.3309L107.142 45.62L99.3979 94.8301L131.927 97.509L139.288 47.3309ZM141.179 44.4044C141.922 44.4719 142.485 45.2148 142.372 45.9802L134.493 99.6026C134.403 100.255 133.863 100.683 133.255 100.638L97.4619 97.7116C96.7191 97.6441 96.1562 96.9012 96.2913 96.1133L104.576 43.549C104.666 42.9187 105.183 42.4909 105.769 42.536L141.157 44.4269C141.157 44.4044 141.179 44.4044 141.179 44.4044Z"
        fill="#36C2DB"
        stroke-width="2px"
        style="animation-duration: 1s"
      ></path>
      <path
        class="fillCls1"
        d="M112.161 104.645C115.47 97.2162 118.779 89.7874 122.088 82.3586C123.934 78.2165 126.658 74.5696 130.102 71.6431C131.656 70.315 133.389 69.347 135.055 68.1764C135.37 67.9513 138.567 65.8352 138.612 66.1504C138.724 66.9833 138.837 67.9062 138.364 68.6266C138.049 69.0994 137.554 69.4145 137.103 69.7972C136.068 70.6751 134.447 72.9938 136.833 72.7687C138.342 72.6337 139.962 71.6882 141.133 70.7652C142.394 69.7972 143.452 68.5366 144.172 67.1183C144.33 66.8032 145.5 62.9087 145.253 62.9312C146.311 62.7961 146.738 64.2369 146.783 65.3174C146.851 68.1088 146.918 70.9228 146.986 73.7142C147.031 75.5827 147.031 77.6087 145.951 79.117C144.6 81.0079 142.033 81.4807 139.715 81.7958C137.464 82.111 135.19 82.4261 132.939 82.7413C131.768 82.8989 130.463 83.1465 129.832 84.137C129.585 84.5197 129.472 84.97 129.382 85.3977C127.784 91.9935 126.185 98.5894 124.61 105.208C122.426 114.235 120.085 123.6 114.209 130.803C112.251 122.159 108.536 112.749 112.161 104.645Z"
        fill="#FDC485"
        stroke-width="2px"
        style="animation-duration: 1s"
      ></path>
      <path
        class="fillCls3"
        d="M30.3091 127.134C31.3221 123.78 32.3126 120.448 33.3256 117.094C34.4962 113.222 35.6668 109.305 37.7379 105.838C40.5068 101.201 44.6939 97.6213 48.5434 93.8168C54.3739 88.0314 60.0693 81.2554 68.0834 79.4545C70.0869 79.0043 72.1579 78.8917 74.1615 78.4415C76.6602 77.8787 78.5962 75.8527 81.005 75.47C83.6163 75.0647 86.5653 75.9652 88.6589 77.5185C89.7844 78.3514 90.7524 79.4095 91.6079 80.5125C92.0356 81.0753 92.4633 81.6381 92.8685 82.2234C96.5154 87.311 99.8696 92.6237 102.909 98.094C104.439 100.84 105.88 103.609 107.253 106.423C107.614 107.189 108.424 110.025 109.257 110.34C109.257 110.34 109.437 107.504 111.373 106.873C112.296 111.623 120.355 116.959 121.436 117.004C122.359 117.049 120.895 122.159 120.693 122.677C119.59 125.536 118.216 128.485 115.673 130.308C114.119 131.434 111.576 132.379 109.617 131.906C108.604 131.659 107.704 131.096 106.871 130.466C103.404 127.922 100.657 124.568 97.9336 121.236C96.8981 119.975 95.8625 118.715 95.0521 117.296C95.0521 118.399 94.6244 119.412 93.9941 120.313C93.3187 121.303 92.5308 122.024 91.5854 122.744C89.0641 124.658 85.4397 125.535 83.3912 127.989C82.8059 128.687 82.3782 129.498 81.7253 130.128C79.9244 131.771 77.178 131.366 74.9494 131.231C72.0229 131.051 69.1189 130.781 66.1924 130.781C61.6901 130.758 57.1653 131.163 52.663 130.668C48.2958 130.195 44.0861 128.867 39.899 127.584C38.2556 127.066 36.5898 126.571 34.8789 126.661C33.1681 126.751 31.3896 127.607 30.6693 129.16C29.9714 128.822 30.084 127.854 30.3091 127.134Z"
        fill="#21B787"
        stroke-width="2px"
        style="animation-duration: 1s"
      ></path>
      <path
        class="fillCls1"
        d="M97.709 35.7822C97.709 35.7822 100.861 50.6398 93.4318 59.8695H85.5528L82.8514 69.5495L78.7994 51.8104L97.709 35.7822Z"
        fill="#FDC485"
        stroke-width="2px"
        style="animation-duration: 1s"
      ></path>
      <path
        class="fillCls2"
        d="M89.8976 22.7481C90.3704 22.7706 90.8431 22.8382 91.2933 22.9507C93.7021 23.6036 95.4805 25.9223 96.471 28.0834C97.9567 31.325 99.2624 34.7693 99.2849 38.3486C99.3074 41.9279 97.8442 45.6873 94.8276 47.6008C91.8111 49.5143 87.5114 49.4918 85.4178 52.3733C83.4593 55.0746 84.4948 58.834 85.4628 62.0307C86.4083 65.1373 87.1962 68.3564 87.1062 71.5981C87.0161 74.8397 85.9356 78.1714 83.5944 80.4226C81.5008 82.4486 78.5743 83.4391 75.6929 83.9569C73.5092 84.3396 71.078 84.6097 69.6598 86.2981C68.9169 87.176 68.6017 88.3016 68.2191 89.3821C66.8909 93.1866 64.8198 96.7209 62.1635 99.7374C59.6197 102.641 56.5356 105.028 53.4965 107.414C51.8757 108.674 50.2324 109.958 48.3414 110.746C46.0452 111.714 43.5014 111.916 41.0252 112.029C32.2457 112.366 23.4212 111.421 14.9118 109.192C9.46406 107.774 3.38596 105.005 2.19285 99.5123C1.06727 94.2671 5.07434 89.3146 9.32901 86.0504C18.0184 79.4095 28.6439 75.9428 38.1887 70.6076C40.9576 69.0543 43.659 67.3209 45.8426 65.0022C51.7406 58.7665 52.8662 49.6043 56.0854 41.6578C58.314 36.1425 61.5331 30.7397 66.193 26.9128C68.5342 24.9993 71.2356 23.536 74.1621 22.7932C75.5353 22.4555 77.0886 22.1403 78.4618 22.0278C80.3077 21.8477 81.816 22.5906 83.5944 22.9057C85.6655 23.2659 87.8716 22.6356 89.8976 22.7481Z"
        fill="#F26C5D"
        stroke-width="2px"
        style="animation-duration: 1s"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "StrappError4",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.error4 {
  animation: error4-blink 1s infinite;
}
@keyframes error4-blink {
  0% {
    visibility: visible;
  }
  50% {
    visibility: hidden;
  }
  100% {
    visibility: hidden;
  }
}
@media (prefers-reduced-motion: reduce) {
  .error4 {
    animation: none;
  }
}
</style>
